import type {
  EnterpriseGroupListApiData,
  EnterpriseGroupListApiResponses,
  EnterpriseGroupMinimalListApiData,
  EnterpriseGroupMinimalListApiResponses,
  OperationLayerListApiData,
  OperationLayerListApiResponses,
  OperationLayerMinimalListApiData,
  OperationLayerMinimalListApiResponses,
  PermissionListApiData,
  PermissionListApiResponses,
  PermissionUsageApiData,
  PermissionUsageApiResponses,
  PolicyCreateApiData,
  PolicyCreateApiResponses,
  PolicyDeleteApiData,
  PolicyDeleteApiResponses,
  PolicyListApiData,
  PolicyListApiResponses,
  RoleCreateApiData,
  RoleCreateApiResponses,
  RoleDeleteApiData,
  RoleDeleteApiResponses,
  RoleGetApiData,
  RoleGetApiResponses,
  RoleListApiData,
  RoleListApiResponses,
  RolePermissionAddApiData,
  RolePermissionAddApiResponses,
  RolePermissionRemoveApiData,
  RolePermissionRemoveApiResponses,
  RoleUpdateApiData,
  RoleUpdateApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getIamUrls = {
  getPaginatedIamRoles: dataEndpoint<RoleListApiData, RoleListApiResponses>({
    getUrl: (queryParams) => apiUrl('iam/roles/', queryParams)
  }),
  getIamRole: dataEndpoint<RoleGetApiData, RoleGetApiResponses>({
    getUrl: ({ pk }) => apiUrl(`iam/roles/${encodeURIComponent(pk)}/`)
  }),
  postIamRole: responseEndpoint<RoleCreateApiData, RoleCreateApiResponses>({
    getUrl: () => apiUrl('iam/roles/create/'),
    getBody: (data) => data
  }),
  patchIamRole: responseEndpoint<RoleUpdateApiData, RoleUpdateApiResponses>({
    getUrl: ({ pk }) => apiUrl(`iam/roles/${encodeURIComponent(pk)}/update/`),
    getBody: ({ pk: _, ...data }) => data
  }),
  deleteIamRole: dataEndpoint<RoleDeleteApiData, RoleDeleteApiResponses>({
    getUrl: ({ pk }) => apiUrl(`iam/roles/${encodeURIComponent(pk)}/delete/`)
  }),
  postIamRolePermissionAdd: responseEndpoint<RolePermissionAddApiData, RolePermissionAddApiResponses>({
    getUrl: ({ pk }) => apiUrl(`iam/roles/${encodeURIComponent(pk)}/permissions/add/`),
    getBody: ({ pk: _, ...data }) => data
  }),
  deleteIamRolePermissionRemove: responseEndpoint<RolePermissionRemoveApiData, RolePermissionRemoveApiResponses>({
    getUrl: ({ pk, permissionId }) =>
      apiUrl(`iam/roles/${encodeURIComponent(pk)}/permissions/remove/`, { permissionId })
  }),
  getPaginatedIamPolicies: dataEndpoint<PolicyListApiData, PolicyListApiResponses>({
    getUrl: (queryParams) => apiUrl('iam/policies/', queryParams)
  }),
  postIamPolicy: responseEndpoint<PolicyCreateApiData, PolicyCreateApiResponses>({
    getUrl: () => apiUrl('iam/policies/create/'),
    getBody: (data) => data
  }),
  deleteIamPolicy: dataEndpoint<PolicyDeleteApiData, PolicyDeleteApiResponses>({
    getUrl: ({ pk }) => apiUrl(`iam/policies/${pk}/delete/`)
  }),
  getPaginatedIamPermissions: dataEndpoint<PermissionListApiData, PermissionListApiResponses>({
    getUrl: (queryParams) => apiUrl('iam/permissions/', queryParams),
    skipBodyTransformation: true
  }),
  getIamPermissionUsage: dataEndpoint<PermissionUsageApiData, PermissionUsageApiResponses>({
    getUrl: (queryParams) => apiUrl('iam/permissions/usage/', queryParams)
  }),
  getPaginatedEnterpriseGroups: dataEndpoint<EnterpriseGroupListApiData, EnterpriseGroupListApiResponses>({
    getUrl: (queryParams) => apiUrl('enterprise-groups/', queryParams)
  }),
  getPaginatedMinimalEnterpriseGroups: dataEndpoint<
    EnterpriseGroupMinimalListApiData,
    EnterpriseGroupMinimalListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('enterprise-groups/minimal/', queryParams)
  }),
  getPaginatedOperationLayers: dataEndpoint<OperationLayerListApiData, OperationLayerListApiResponses>({
    getUrl: (queryParams) => apiUrl('operation-layers/', queryParams)
  }),
  getPaginatedMinimalOperationLayers: dataEndpoint<
    OperationLayerMinimalListApiData,
    OperationLayerMinimalListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('operation-layers/minimal/', queryParams)
  })
};
